import React from 'react';
import { Shield, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 py-12 px-4 text-center" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-165">
          <Shield className="w-6 h-6 text-brand-green" data-id="element-166" />
          <h2 className="text-xl font-montserrat font-bold tracking-wider text-slate-dark" data-id="element-167">
            AVANZAPRO<sup className="text-xs" data-id="element-168">®</sup>
          </h2>
        </div>

        <p className="text-slate text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-169">
          Recursos educativos e informativos para comprender el sistema
          financiero en Uruguay.
          <br data-id="element-170" />
          <br data-id="element-171" />
          Este material tiene fines exclusivamente educativos y no constituye
          asesoramiento legal o financiero personalizado.
        </p>

        <div className="flex flex-col items-center gap-3 text-sm text-brand-green font-medium mb-12" data-id="element-172">
          <a href="mailto:soporteavanzapro@gmail.com" className="flex items-center gap-2 hover:text-brand-dark transition-colors" data-id="element-173">
            <Mail className="w-4 h-4" data-id="element-174" /> soporteavanzapro@gmail.com
          </a>
          <a href="https://www.avanzapro.store" className="flex items-center gap-2 hover:text-brand-dark transition-colors" data-id="element-175">
            <Globe className="w-4 h-4" data-id="element-176" /> www.avanzapro.store
          </a>
        </div>

        <div className="text-xs text-slate-light space-y-2" data-id="element-177">
          <p data-id="element-178">© AvanzaPro® 2026 — Todos los derechos reservados</p>
          <p data-id="element-179">Prohibida la reproducción sin autorización expresa.</p>
        </div>
      </div>
    </footer>;
}